import $ from 'jquery';

const $externalLinkBtn = $('.js-external-link');
const $externalModal = $('.js-external-link-modal');
const $externalLinkCloseBtn = $('.js-close-external-modal');

if ($externalLinkBtn.length > 0) {
  $externalLinkBtn.on('click tap', () => {
    $externalModal.addClass('is-active');
  });

  $externalLinkCloseBtn.on('click tap', () => {
    $externalModal.removeClass('is-active');
  });
}



// WEBPACK FOOTER //
// ./js/components/init-external-link-modal.js